<div class="flex flex-row items-center justify-start gap-1 logo-container">
  <a [ngClass]="type === logoType.AUTHENTICATED ? 'logo-button-authenticated' : ''" class="logo-button" routerLink="" (click)="navigateHome()"
     (keydown.tab)="displaySkipToMainContent()" (keydown.shift.tab)="displaySkipToMainContent()" role="button" [class]="customClass">
    <div class="flex flex-row items-center justify-center gap-3">
    @switch (type) {
      @case (logoType.AUTHENTICATED) {
        <img class="logo-img" src="assets/img/Intrafi_header_logo_blue.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo"/>
      }
      @case (logoType.PUBLIC) {
        <img src="assets/img/Intrafi_header_logo_white.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo"/>
      }
      @case (logoType.NEW_PUBLIC) {
        <img src="assets/img/Intrafi_header_logo_black.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo" class="dcp-focus-outline hidden lg:block"/>
        <img src="assets/img/Intrafi_header_logo_blue_mobile.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo" class="w-full lg:hidden"/>
      }
      @case (logoType.REGISTRATION) {
        <img src="assets/img/Intrafi_header_logo_black.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo" class="dcp-focus-outline hidden lg:block"/>
        <img src="assets/img/Intrafi_header_logo_blue_mobile.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo" class="w-full lg:hidden"/>
      }
      @case (logoType.LOGIN) {
        <img src="assets/img/Intrafi_header_logo_white.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo" class="login-logo dcp-focus-outline--secondary"/>
      }
      @case (logoType.LOGIN_MOBILE) {
        <img src="assets/img/Intrafi_header_logo_blue_mobile.svg" alt="IntraFi Logo" role="link" aria-hidden="false" aria-label="IntraFi Logo" class="w-full"/>
      }
    }

    @if (type === logoType.AUTHENTICATED) {
      <p class="logo-text heading-sm-semibold color-content-subtle">Depositor Control Panel</p>
    }
    </div>
  </a>
</div>
